import React from 'react';
import uniqid from 'uniqid';
import { Link as RouterLink } from 'react-router-dom';


import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import { formatDate } from 'helpers/dates-formatter';

interface CardItem {
  name?: string;
  coverDescription?: string;
  route: string;
  date?: string;
  coverImage?: string;
}

interface CardsProps {
  items?: CardItem[];
  contentType?: string;
}

const Cards = ({ items = [], contentType }: CardsProps): React.JSX.Element => (
  <ResponsiveWrapper customClass="grid mobile:grid-cols-1 tablet:grid-cols-2 xs:grid-cols-3 lg:grid-cols-4 gap-6">
    {items.map(({ name, coverDescription, route, date, coverImage }) => (
      <RouterLink
        to={route}
        key={uniqid()}
        className="border border-navy-200 rounded w-full"
      >
        {coverImage ? (
          <img
            src={coverImage}
            alt={`${contentType} ${name}`}
            className="block w-full h-auto rounded-tl rounded-tr"
          />
        ) : (
          <div className="w-full aspect-[16/10] tablet:bg-bottom categories-bg rounded-tl rounded-tr"></div>
        )}

        <Box sx={{ p: 2.5 }}>
          <Stack
            direction="row"
            sx={{ justifyContent: 'space-between', alignItems: 'center' }}
          >
            <Box
              sx={{
                bgcolor: 'tokens.navy.50',
                px: 1.25,
                py: 0.5,
                borderRadius: '0.25rem',
                width: 'fit-content',
                color: 'tokens.navy.800',
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
              }}
            >
              {contentType}
            </Box>
            {date && (
              <Box
                sx={{
                  color: 'tokens.navy.500',
                  fontSize: '0.875rem',
                  lineHeight: '1.25rem',
                  fontWeight: 600,
                }}
              >
                {formatDate(date, 'MMM D, YYYY') || date}
              </Box>
            )}
          </Stack>

          <h3 className="text-neutral-900 text-xl font-semibold py-2">
            {name}
          </h3>
          <div className="text-neutral-900 text-base">{coverDescription}</div>
        </Box>
      </RouterLink>
    ))}
  </ResponsiveWrapper>
);

export default Cards;
